import { Icon, IconButton, Separator } from '@project44/manifest-ds';

import { scopedT } from '../../../../../../utils/helpers/scopedT';
import { createMarkerReference } from '../../draw';

import { CustomButtonGroup } from './styles';

interface ZoomComponentProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
}

const ZoomToggleComponent = ({ onZoomIn, onZoomOut }: ZoomComponentProps) => {
  const t = scopedT();

  return (
    <CustomButtonGroup>
      <IconButton
        className="mapbox-zoom-in-ctrl"
        variant="secondary"
        onClick={onZoomIn}
        title={t('map.zoomIn')}
        size="small"
      >
        <Icon icon="add" />
      </IconButton>
      <Separator />
      <IconButton
        className="mapbox-zoom-out-ctrl"
        variant="secondary"
        onClick={onZoomOut}
        title={t('map.zoomOut')}
        size="small"
      >
        <Icon icon="remove" />
      </IconButton>
    </CustomButtonGroup>
  );
};

export default class Zoom {
  private _container: HTMLElement;

  private _zoomInclickHandler: () => void;
  private _zoomOutclickHandler: () => void;

  constructor({ onZoomIn, onZoomOut }: ZoomComponentProps) {
    this._zoomInclickHandler = onZoomIn;
    this._zoomOutclickHandler = onZoomOut;
  }

  onAdd() {
    this._container = createMarkerReference(
      <ZoomToggleComponent
        onZoomIn={this._zoomInclickHandler}
        onZoomOut={this._zoomOutclickHandler}
      />,
    );
    this._container.className = 'mapboxgl-ctrl';
    return this._container;
  }

  onRemove() {
    this._container.parentNode?.removeChild(this._container);
  }
}
